<template>
  <div>
    
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/adminTools"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4><u>api Log entries</u></h4>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-3">
        Ημερομηνία
        <DxDateBox :value="date" picker-type="calendar" display-format="dd/MM/yyyy" @value-changed="setSelectedDate" />
      </div>
      <div class="col-md-3">
        <DxLoadIndicator id="image-indicator" :height="40" :width="40" :visible="loadIndicatorVisible" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 grid-pad">
        <DxDataGrid :data-source="logs" :allow-column-reordering="true" :allow-column-resizing="true"
          :column-auto-width="true" :show-borders="true" key-expr="Id" :show-row-lines="true"
          :row-alternation-enabled="true" width="100%">
          <DxPaging :page-size="20" :enabled="true" />
          <DxEditing :allow-updating="true" :use-icons="true" mode="cell" />
          <DxHeaderFilter :visible="true" />
          <DxFilterRow :visible="true" />
          <DxSearchPanel :visible="true" />
          <DxExport :enabled="true" :allow-export-selected-data="true" />
          />

          <!--  <DxColumn  caption="Κωδικός" data-field="Id" data-type="integer" :visible="false">
                </DxColumn> -->
          <DxSelection mode="multiple" />
          <DxColumn caption="Ώρα" :allow-editing="false" data-field="CallDate" data-type="date" :visible="true"
            width="200px" alignment="center" format="hh:mm:ss" :allow-filtering="false">
          </DxColumn>
          <DxColumn caption="Ip" :allow-editing="false" data-field="IpAddress" data-type="string" :visible="true"
            width="200px" alignment="left">
          </DxColumn>
          <DxColumn caption="Κλήση" cell-template="cellTemplate1" :allow-editing="false" data-field="CallJson"
            data-type="string" :visible="true" width="200px" alignment="left">
          </DxColumn>
          <DxColumn caption="Απάντηση" cell-template="cellTemplate2" :allow-editing="false" data-field="ResponseJson"
            data-type="string" :visible="true" width="200px" alignment="left">
          </DxColumn>
          <DxColumn caption="Επιτυχής" :allow-editing="false" data-field="IsSuccess" data-type="boolean" :visible="true"
            width="180px" alignment="left">
          </DxColumn>
          <template #cellTemplate1="{ data }">
            <a href="#" @click="onCallJsonClick(data.value)">{{
              data.value
            }}</a>
          </template>
          <template #cellTemplate2="{ data }">
            <a href="#" @click="onResponseJsonClick(data.value)">{{
              data.value
            }}</a>
          </template>
        </DxDataGrid>
      </div>
    </div>
    <DxPopup :visible="popupIsVisible" :drag-enabled="false" :close-on-outside-click="false" :show-title="true"
      :show-close-button="false" :width="500" :height="350" :title="popupTitle">
      <div class="row">
        <textarea v-model="popupContent" placeholder="Περιγραφή" rows="10" cols="50" style="width: 100%" />
        </div>
      <div class="row" style="padding-top: 20px">
        <DxButton
          text="Επιστροφή"
          type="danger"
          styling-mode="contained"
          @click="onClosePopup"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import BackButton from "../../components/shared/backButton";
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxEditing,
  DxExport,
  DxSelection,
} from "devextreme-vue/data-grid";
import DxDateBox from "devextreme-vue/date-box";
import { DxPopup } from "devextreme-vue/popup";
import { DxButton as DxButton } from "devextreme-vue/button";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

export default {
  components: {
    BackButton,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxEditing,
    DxDateBox,
    DxPopup,
    DxButton,
    DxExport,
    DxSelection,
    DxLoadIndicator,
  },
  data() {
    return {
      date: this.$moment().format("MM/DD/YYYY"),
      logs: [],
      popupIsVisible: false,
      popupTitle: "",
      popupContent: "",
      loadIndicatorVisible: false,
    };
  },

  created() {},
  methods: {
    async setSelectedDate(e) {
      this.loadIndicatorVisible = true;
      this.logs = [];
      if (e.value != null) {
        const res = await mainService.get(
          `/ApiLogs/GetApiLogsByDate?date=${e.value}`
        );
        this.logs = res.data;
      }
      this.loadIndicatorVisible = false;
    },
    onCallJsonClick(e) {
      this.popupContent = e;
      this.popupTitle = "Κλήση ";
      this.popupIsVisible = true;
    },
    onResponseJsonClick(e) {
      this.popupContent = e;
      this.popupTitle = "Απάντηση ";
      this.popupIsVisible = true;
    },
    onClosePopup() {
      this.popupIsVisible = false;
    },
  },
  computed: {},
  async mounted() {
    this.loadIndicatorVisible = true;
    const res = await mainService.get(
      `/ApiLogs/GetApiLogsByDate?date=${this.date}`
    );
    this.logs = res.data;
    this.loadIndicatorVisible = false;
  },
};
</script>

<style>
</style>